import { AuthenticationState } from './state';
import {
    AuthenticationAction,
    KC_FIND_USERS_FAILURE,
    KC_FIND_USERS_REQUEST,
    KC_FIND_USERS_SUCCESS,
    SET_SPOC,
    SET_SPOC_FINISHED,
    SET_SPOCS
} from './types';
import { browserClient } from '../../react-query';

const initialAuthenticationState = {} as AuthenticationState;

export function authenticationReducer(
    authentication: AuthenticationState = initialAuthenticationState,
    action: AuthenticationAction
): Partial<AuthenticationState> {
    switch (action.type) {
        case SET_SPOC:
            browserClient.clear();
            return { ...authentication, spoc: action.payload, lockSpocChange: true };
        case SET_SPOCS:
            browserClient.clear();
            return { ...authentication, spocs: action.payload };

        case SET_SPOC_FINISHED:
            return { ...authentication, lockSpocChange: false };

        case KC_FIND_USERS_REQUEST:
            return { ...authentication, impersonation: { loading: true } };

        case KC_FIND_USERS_SUCCESS:
            return {
                ...authentication,
                impersonation: { users: action.payload, loading: false }
            };

        case KC_FIND_USERS_FAILURE:
            return { ...authentication, impersonation: { loading: false } };

        default:
            return authentication;
    }
}
